/**
 * Centralized Google Maps configuration for the ecommerce app.
 *
 * The browser key is read from REACT_APP_GOOGLE_MAPS_API_KEY. We use
 * the `places` library for the checkout address autocomplete.
 */

export const GOOGLE_MAPS_API_KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY ?? '';

export const GOOGLE_MAPS_SCRIPT_ID = 'vinpulse-ecom-google-maps-script';

export const GOOGLE_MAPS_LIBRARIES: ('places' | 'geometry' | 'drawing' | 'visualization')[] = [
  'places',
];

export function isMapsConfigured(): boolean {
  return GOOGLE_MAPS_API_KEY.length > 0;
}
